import type React from 'react';

import { Box, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';

import ArrowForwardIcon from '@/assets/icons/common/ArrowForwardIcon.png';
import CloseIcon from '@/assets/icons/common/CloseIcon.svg';
import { ModalHeaderCloseIconStyles } from '@/components/profile/modalHeader/ModalHeader.styles.ts';

type Props = {
  onClose: () => void;
  pageTitle?: string;
  title: string;
};

export const ModalHeader: React.FC<Props> = ({ onClose, pageTitle, title }) => {
  const parsedTitle = pageTitle ? (
    <Stack direction="row" sx={{ alignItems: 'center' }}>
      <Typography sx={{ color: 'primary.grey', pr: 3 }} variant="f20Regular">
        {pageTitle}
      </Typography>
      <img alt=">" src={ArrowForwardIcon} />
      <Typography component="span" sx={{ color: 'primary.black', pl: 3 }} variant="f20Medium">
        {title}
      </Typography>
    </Stack>
  ) : (
    <Typography sx={{ color: 'primary.black' }} variant="f20Medium">
      {title}
    </Typography>
  );

  return (
    <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between', px: 5 }}>
      {parsedTitle}
      <Box onClick={onClose} sx={ModalHeaderCloseIconStyles}>
        <img alt="Close" src={CloseIcon} />
      </Box>
    </Stack>
  );
};
